export default __webpack_public_path__ + "static/media/1874.f613c002.jpg";